// extracted by mini-css-extract-plugin
export var backToWebsiteButton = "SubscribeModalThankYou-module--back-to-website-button--f9a98";
export var icon = "SubscribeModalThankYou-module--icon--04200";
export var subscriptionConfirmedMessage = "SubscribeModalThankYou-module--subscription-confirmed-message--d344c";
export var thankYouBody = "SubscribeModalThankYou-module--thank-you-body--9947f";
export var thankYouMessage = "SubscribeModalThankYou-module--thank-you-message--e6194";
export var thankYouMessageContainer = "SubscribeModalThankYou-module--thank-you-message-container--0d7bd";
export var thankYouTitle = "SubscribeModalThankYou-module--thank-you-title--0eea6";
export var thankYouTitleCrossBrand = "SubscribeModalThankYou-module--thank-you-title-cross-brand--b8fa9";
export var variantCompact = "SubscribeModalThankYou-module--variant-compact--5902e";
export var variantWide = "SubscribeModalThankYou-module--variant-wide--f7d4e";